import { Button, DatePicker, Drawer, Form, Input, Radio, Select, InputNumber } from "antd";
import moment from "moment";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import {
	loadSingelLeaveApplication,
	reviewLeaveApplication,
} from "../../../redux/rtk/features/leave/leaveSlice";
import getUserFromToken from "../../../utils/getUserFromToken";
import { useParams } from "react-router-dom";
import dayjs from "dayjs";
import { getAllMaster } from "../../../redux/rtk/features/masters/masterSlice";

const ReviewLeavePopup = ({ leaveId, leaveData }) => {
	const { id } = useParams("id"); // Fallback to useParams if leaveId not provided
	const leaveIdToUse = leaveId || id;
	const dispatch = useDispatch();
	const [form] = Form.useForm();
	const [loader, setLoader] = useState(false);
	// const data = useSelector((state) => state.leave.leave);
	const data = leaveData;
	const userId = getUserFromToken();
	const [status, setStatus] = useState(null);
	const [daySelectionType, setDaySelectionType] = useState("full");
	const [startDayPart, setStartDayPart] = useState(1);
	const [endDayPart, setEndDayPart] = useState(1);
	const [totalDays, setTotalDays] = useState(1);

	const masterData = useSelector((state) => state.masters.masters);
	const leaveDayType = masterData?.LeaveDayType;

	useEffect(() => {
		dispatch(getAllMaster());
	}, [dispatch]);

	// useEffect(() => {
	// 	if (data) {
	// 		const initialValues = {
	// 			acceptLeaveFrom: data?.leaveFrom ? moment(data.leaveFrom) : null,
	// 			acceptLeaveTo: data?.leaveTo ? moment(data.leaveTo) : null,
	// 			reviewComment: data?.reviewComment || "",
	// 			status: null,
	// 			leaveTypeId: data?.LeaveTypeId,
	// 			StartDateDayTypeId: data?.StartDateDayTypeId || 1,
	// 			EndDateDayTypeId: data?.EndDateDayTypeId || 1,
	// 		};
	// 		form.setFieldsValue(initialValues);
	// 		setTotalDays(data?.LeaveInDays || 1);
	// 		setDaySelectionType(data?.IsCustom ? "custom" : "full");
	// 		setStartDayPart(data?.StartDateDayTypeId || 1);
	// 		setEndDayPart(data?.EndDateDayTypeId || 1);
	// 	}
	// }, [data, form]);

	useEffect(() => {
		if (daySelectionType === "custom") {
			const start = form.getFieldValue("acceptLeaveFrom");
			const end = form.getFieldValue("acceptLeaveTo");
			if (start && end) {
				const daysBetween = dayjs(end).diff(dayjs(start), "day");
				const startVal = startDayPart / 4 || 0.25;
				const endVal = endDayPart / 4 || 1.0;
				let total = 0;
				if (daysBetween === 0) {
					total = endVal - startVal + 0.25;
				} else {
					total = daysBetween + endVal - startVal + 0.25;
				}
				total = Math.round(total * 4) / 4;
				setTotalDays(total);
				form.setFieldsValue({ totalleaveDays: total });
			}
		} else {
			const start = form.getFieldValue("acceptLeaveFrom");
			const end = form.getFieldValue("acceptLeaveTo");
			if (start && end) {
				const diff = dayjs(end).diff(start, "day") + 1;
				setTotalDays(diff);
				form.setFieldsValue({ totalleaveDays: diff });
			}
		}
	}, [daySelectionType, startDayPart, endDayPart, form]);

	const onFinish = async (values) => {
		try {
			setLoader(true);
			const formData = {
				...values,
				EmployeeLeaveId: Number(data.EmployeeLeaveId),
				IsCustomApproved: daySelectionType === "custom",
				LeaveStatusId: status,
				ApprovedStartDate: values.acceptLeaveFrom
					? dayjs(values.acceptLeaveFrom).format("YYYY-MM-DD")
					: null,
				ApprovedEndDate: values.acceptLeaveTo
					? dayjs(values.acceptLeaveTo).format("YYYY-MM-DD")
					: null,
				ApprovedStartDateDayTypeId: daySelectionType === "custom" ? startDayPart : 1,
				ApprovedEndDateDayTypeId: daySelectionType === "custom" ? endDayPart : 1,
				ApprovedLeaveInDays: totalDays,
				DataStatus: 1
			};
			// // console.log("SubmittedValues", formData);
			
			const resp = await dispatch(
				reviewLeaveApplication({ id: leaveIdToUse, values: formData })
			);
			if (resp.payload.message === "success") {
				setOpen(false);
				dispatch(loadSingelLeaveApplication(leaveIdToUse));
				toast.success("Leave reviewed successfully");
			} else {
				toast.error("Failed to review leave");
			}
		} catch (error) {
			toast.error("An error occurred");
		} finally {
			setLoader(false);
		}
	};

	const onFinishFailed = () => {
		toast.warning("Please fill all required fields");
		setLoader(false);
	};

	const [open, setOpen] = useState(false);
	// const showDrawer = () => setOpen(true);
	const showDrawer = () => {
		if (data) {
			const initialValues = {
				acceptLeaveFrom: data?.StartDate ? dayjs(data.StartDate) : null,
				acceptLeaveTo: data?.EndDate ? dayjs(data.EndDate) : null,
				reviewComment: data?.reviewComment || "",
				status: null,
				leaveTypeId: data?.LeaveTypeId,
				StartDateDayTypeId: data?.StartDateDayTypeId || 1,
				EndDateDayTypeId: data?.EndDateDayTypeId || 1,
				totalleaveDays: data?.LeaveInDays || 1,
			};
			form.setFieldsValue(initialValues);
			setDaySelectionType(data?.IsCustom ? "custom" : "full");
			setStartDayPart(data?.StartDateDayTypeId || 1);
			setEndDayPart(data?.EndDateDayTypeId || 1);
			setTotalDays(data?.LeaveInDays || 1);
		}
		setOpen(true);
	};

	const onClose = () => {
		setOpen(false);
		setStatus(null);
	};

	return (
		<>
			<Button
				onClick={() => {
					// console.log("Review Leave button clicked");
					showDrawer();
				}}
				className="mt-4"
				type="primary"
			>
				Review Leave
			</Button>

			{data && (
				<Drawer
					width={720}
					title="Leave Review"
					placement="right"
					onClose={onClose}
					open={open}
				>
					<h2 className="text-2xl font-semibold mb-4 text-center mt-5">
						Approve Leave
					</h2>
					<Form
						className="list-inside list-none border-2 border-inherit rounded px-5 py-5 m-5 mt-10"
						form={form}
						style={{ marginBottom: "40px" }}
						name="basic"
						labelCol={{ span: 7 }}
						wrapperCol={{ span: 12 }}
						onFinish={onFinish}
						onFinishFailed={onFinishFailed}
						autoComplete="off"
					>
						<Form.Item
							label="Leave Type"
							name="leaveTypeId"
							rules={[{ required: true, message: "Please select a leave type!" }]}
						>
							<Select placeholder="Select leave type">
								{masterData?.LeaveTypeMaster?.map((type) => (
									<Select.Option
										key={type.LeaveTypeId}
										value={type.LeaveTypeId}
									>
										{type.LeaveTypeName}
									</Select.Option>
								))}
							</Select>
						</Form.Item>

						<Form.Item
							label="Accept From"
							name="acceptLeaveFrom"
							rules={[{ required: true, message: "Please input Date!" }]}
						>
							<DatePicker
								format="DD-MM-YYYY"
								onChange={() => {
									const start = form.getFieldValue("acceptLeaveFrom");
									const end = form.getFieldValue("acceptLeaveTo");
									if (start && end && daySelectionType === "full") {
										const diff = dayjs(end).diff(start, "day") + 1;
										setTotalDays(diff);
										form.setFieldsValue({ totalleaveDays: diff });
									}
								}}
							/>
						</Form.Item>

						<Form.Item
							label="Accept To"
							name="acceptLeaveTo"
							rules={[{ required: true, message: "Please input Date!" }]}
						>
							<DatePicker
								format="DD-MM-YYYY"
								onChange={() => {
									const start = form.getFieldValue("acceptLeaveFrom");
									const end = form.getFieldValue("acceptLeaveTo");
									if (start && end && daySelectionType === "full") {
										const diff = dayjs(end).diff(start, "day") + 1;
										setTotalDays(diff);
										form.setFieldsValue({ totalleaveDays: diff });
									}
								}}
							/>
						</Form.Item>

						<Form.Item label="Total Days" name="totalleaveDays">
							<InputNumber disabled value={totalDays} />
						</Form.Item>

						<Form.Item label="Leave Duration Type">
							<Select
								value={daySelectionType}
								onChange={(value) => setDaySelectionType(value)}
							>
								<Select.Option value="full">Full Days</Select.Option>
								<Select.Option value="custom">Custom</Select.Option>
							</Select>
						</Form.Item>

						{daySelectionType === "custom" && (
							<>
								<Form.Item label="Start Day Type" name="StartDateDayTypeId">
									<Select
										value={startDayPart}
										onChange={(value) => setStartDayPart(value)}
									>
										{leaveDayType?.map((type) => (
											<Select.Option
												key={type.LeaveDayTypeId}
												value={type.LeaveDayTypeId}
											>
												{type.LeaveDayTypeName || `Quarter ${type.LeaveDayTypeId}`}
											</Select.Option>
										))}
									</Select>
								</Form.Item>

								<Form.Item label="End Day Type" name="EndDateDayTypeId">
									<Select
										value={endDayPart}
										onChange={(value) => setEndDayPart(value)}
									>
										{leaveDayType?.map((type) => (
											<Select.Option
												key={type.LeaveDayTypeId}
												value={type.LeaveDayTypeId}
											>
												{type.LeaveDayTypeName || `Quarter ${type.LeaveDayTypeId}`}
											</Select.Option>
										))}
									</Select>
								</Form.Item>
							</>
						)}

						<Form.Item label="Comment" name="reviewComment">
							<Input.TextArea rows={4} />
						</Form.Item>

						{status === null && (
							<p className="text-red-500 text-center mb-3">
								Please select status
							</p>
						)}

						<Form.Item
							label="Select Status"
							name="status"
							rules={[{ required: true, message: "Please input Status!" }]}
						>
							<Radio.Group
								buttonStyle="solid"
								onChange={(e) => setStatus(e.target.value)}
							>
								<Radio.Button value={1}>APPROVED</Radio.Button>
								<Radio.Button value={0}>REJECTED</Radio.Button>
							</Radio.Group>
						</Form.Item>

						<Form.Item wrapperCol={{ offset: 7, span: 12 }}>
							<Button
								type="primary"
								size="middle"
								htmlType="submit"
								block
								disabled={status === null}
								loading={loader}
							>
								Submit Review
							</Button>
						</Form.Item>
					</Form>
				</Drawer>
			)}
		</>
	);
};

export default ReviewLeavePopup;

// import { Button, DatePicker, Drawer, Form, Input, Radio } from "antd";

// import moment from "moment";
// import { useEffect, useState } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { useParams } from "react-router-dom";
// import { toast } from "react-toastify";
// import {
// 	loadSingelLeaveApplication,
// 	reviewLeaveApplication,
// } from "../../../redux/rtk/features/leave/leaveSlice";
// import getUserFromToken from "../../../utils/getUserFromToken";

// const ReviewLeavePopup = () => {
// 	const { id } = useParams("id");
// 	const dispatch = useDispatch();
// 	const [form] = Form.useForm();
// 	const [loader, setLoader] = useState(false);
// 	const data = useSelector((state) => state.leave.leave);
// 	const userId = getUserFromToken();
// 	const [status, setStatus] = useState(null);

// 	const [initialValues, setInitialValues] = useState({});


// 	useEffect(() => {
// 		setInitialValues({
// 			...data,
// 			userId: userId,
// 			status: status,
// 			acceptLeaveFrom: moment(data?.leaveFrom),
// 			acceptLeaveTo: moment(data?.leaveTo),
// 		});
// 	}, [data]);

// 	const onFinish = async (values) => {
// 		const FormData = {
// 			...values,
// 		};
// 		const resp = await dispatch(
// 			reviewLeaveApplication({ id: id, values: FormData })
// 		);

// 		if (resp.payload.message === "success") {
// 			setOpen(false);
// 			dispatch(loadSingelLeaveApplication(id));
// 			setLoader(false);
// 			setStatus(null);
// 		} else {
// 			setLoader(false);
// 		}
// 	};
// 	const onFinishFailed = (errorInfo) => {
// 		toast.warning("Failed at adding department");
// 		setLoader(false);
// 	};
// 	const [open, setOpen] = useState(false);
// 	const showDrawer = () => {
// 		setOpen(true);
// 	};
// 	const onClose = () => {
// 		setOpen(false);
// 		setStatus(null);
// 	};

// 	return (
// 		<>
// 			<Button onClick={showDrawer} className='mt-4' type='primary'>
// 				Review Leave
// 			</Button>
// 			{data && (
// 				<Drawer
// 					width={720}
// 					title='Leave Review'
// 					placement='right'
// 					onClose={onClose}
// 					open={open}>
// 					<h2 className='text-2xl font-semibold mb-4 text-center mt-5'>
// 						Approve Leave
// 					</h2>
// 					<Form
// 						className='list-inside list-none border-2 border-inherit rounded px-5 py-5 m-5 mt-10'
// 						form={form}
// 						style={{ marginBottom: "40px" }}
// 						name='basic'
// 						initialValues={initialValues}
// 						labelCol={{
// 							span: 7,
// 						}}
// 						wrapperCol={{
// 							span: 12,
// 						}}
// 						onFinish={onFinish}
// 						onFinishFailed={onFinishFailed}
// 						autoComplete='off'>
// 						<div>
// 							<Form.Item
// 								style={{ marginBottom: "10px" }}
// 								label='Accept From'
// 								name='acceptLeaveFrom'
// 								rules={[
// 									{
// 										required: true,
// 										message: "Please input Date !",
// 									},
// 								]}>
// 								<DatePicker format={"DD-MM-YYYY"} />
// 							</Form.Item>

// 							<Form.Item
// 								style={{ marginBottom: "10px" }}
// 								label='Accept To'
// 								name='acceptLeaveTo'
// 								rules={[
// 									{
// 										required: true,
// 										message: "Please input Date!",
// 									},
// 								]}>
// 								<DatePicker format={"DD-MM-YYYY"} />
// 							</Form.Item>

// 							<Form.Item
// 								style={{ marginBottom: "10px" }}
// 								label='Comment'
// 								name='reviewComment'>
// 								<Input name='reviewComment' />
// 							</Form.Item>

// 							{status === null && (
// 								<p className='text-red-500 text-center mb-3'>
// 									Please select status
// 								</p>
// 							)}

// 							<Form.Item
// 								style={{ marginBottom: "10px" }}
// 								label='Select Status'
// 								name='status'
// 								rules={[
// 									{
// 										required: true,
// 										message: "Please input Status!",
// 									},
// 								]}>
// 								<Radio.Group
// 									buttonStyle='solid'
// 									onChange={(e) => setStatus(e.target.value)}>
// 									<Radio.Button value='ACCEPTED'>ACCEPTED</Radio.Button>
// 									<Radio.Button value='REJECTED'>REJECTED</Radio.Button>
// 								</Radio.Group>
// 							</Form.Item>

// 							<Form.Item
// 								style={{ marginBottom: "10px" }}
// 								wrapperCol={{
// 									offset: 7,
// 									span: 12,
// 								}}>
// 								<Button
// 									onClick={() => setLoader(true)}
// 									type='primary'
// 									size='middle'
// 									htmlType='submit'
// 									block
// 									disabled={status === null}
// 									loading={loader}>
// 									Review Leave
// 								</Button>
// 							</Form.Item>
// 						</div>
// 					</Form>
// 				</Drawer>
// 			)}
// 		</>
// 	);
// };
// export default ReviewLeavePopup;
